module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_002_lg-56533b21.png";